import React, { useEffect, useRef } from 'react';

export enum BannerVariant {
    TIP = 'tip',
    IMPROVEMENT = 'improvement',
    SUGGESTION = 'suggestion'
}

interface IBannerProps {
    // attributes
    analytics?: string;
    dark?: boolean;
    hideCloseButton?: boolean;
    show?: boolean;
    variant?: BannerVariant;
    // event
    onClose?: () => void;
    // extra nous
    dataTestId?: string;
}

export const Banner: React.FC<IBannerProps> = ({
    // slots
    children,
    // attributes
    analytics,
    dark,
    hideCloseButton,
    show,
    variant,
    // event
    onClose,
    // extra nous
    dataTestId
}) => {
    const ref = useRef(null);

    const handleClose = () => {
        onClose();
    };

    useEffect(() => {
        ref.current.addEventListener('dsdBannerClose', () => {
            if (onClose) handleClose();
        });
    }, []);

    return (
        // @ts-ignore
        <dsd-banner
            ref={ref}
            analytics={analytics}
            dark={dark}
            hideCloseButton={hideCloseButton}
            show={show}
            variant={variant}
            onClose={onClose}
            data-testId={dataTestId}
        >
            {children}
            {/* @ts-ignore */}
        </dsd-banner>
    );
};
